<template>
  <div
    class="module module-instagram padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation]"
  >
    <ModuleContainer>
      <ModuleHeading>Instagram</ModuleHeading>
    </ModuleContainer>
  </div>
</template>

<script>
export default {
  name: "instagram",
  props: ["data"],
  computed: {},
  components: {}
};
</script>
